import React from "react";
import {connect} from "react-redux";

import {getUserIdentityStatus} from "state/app/selectors";
import {forceRegistration} from "state/app/actions";
import ModalDialog from "components/ModalDialog";

import "./UserIdentityValidator.css";

class UserIdentityValidator extends React.Component {
  backToRegistration = () => {
    forceRegistration();
  }

  render() {
    const isError = this.props.userIdentityStatus === "error";
    return (
      <ModalDialog fitScreen={true} isOpen={isError}>
        <div className="user-identity-validator">
          <h1 className="user-identity-validator__heading">Oops!</h1>
          <div className="user-identity-validator__body">
            <p>Your identity could not be verified.</p>
            <p>You should be redirected to the registration screen. If not, please close the app and and try again.</p>
          </div>
        </div>
      </ModalDialog>
    )
  }
}
export default connect(
  (state, ownProps) => ({
    userIdentityStatus: getUserIdentityStatus(state)
  }),
  {forceRegistration}
)(UserIdentityValidator)



// WEBPACK FOOTER //
// ./src/components/UserIdentityValidator.js